import { render, staticRenderFns } from "./offers-echart.vue?vue&type=template&id=f36281b4&scoped=true&"
import script from "./offers-echart.vue?vue&type=script&lang=js&"
export * from "./offers-echart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36281b4",
  null
  
)

export default component.exports